var map = {
	"./blog.yml": 52,
	"./cloud.yml": 53,
	"./color.yml": 54,
	"./country.yml": 55,
	"./dio.yml": 56,
	"./doc.yml": 57,
	"./emoji.yml": 58,
	"./flag.yml": 59,
	"./git.yml": 60,
	"./icon.yml": 61,
	"./license.yml": 62,
	"./link.yml": 63,
	"./metrics.yml": 64,
	"./people.yml": 65,
	"./soft.yml": 66,
	"./src.yml": 67,
	"./status.yml": 68,
	"./taxonomy.yml": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;